const getSapBPNumber = (crew) => {
  if (!crew || typeof crew !== 'object') return '';

  const candidates = [
    crew.sapBPNumber,
    crew.sapBpNumber,
    crew.SAPBPNumber,
    crew.sapBPNo,
    crew.sapBpNo,
    crew.businessPartnerNumber,
    crew.crewSapBPNumber
  ];

  const match = candidates.find(
    (value) => value != null && String(value).trim() !== ''
  );
  return match != null ? String(match).trim() : '';
};

const formatCrewDisplayName = (crew) => {
  const name = [crew?.firstName, crew?.lastName].filter(Boolean).join(' ').trim();
  return name || '-';
};

const formatCrewNameWithSapBP = (crew) => {
  const name = formatCrewDisplayName(crew);
  const sapBPNumber = getSapBPNumber(crew);
  if (!sapBPNumber || name === '-') return name;
  return `${name} (${sapBPNumber})`;
};

const formatCrewDropdownLabel = (crew) => {
  if (!crew) return '-';
  if (crew.label) return crew.label;

  const name = [crew?.firstName, crew?.lastName].filter(Boolean).join(' ').trim();
  const sapBPNumber = getSapBPNumber(crew);
  const rankName = crew?.rankName || crew?.positionName || '';
  const codePrefix = crew?.crewCode ? `${crew.crewCode}:` : '';

  let label = `${codePrefix}${name}`.trim();
  if (rankName) {
    label = `${label} ${rankName}`.trim();
  }
  if (sapBPNumber) {
    label = `${label} (${sapBPNumber})`.trim();
  }
  return label || '-';
};

const buildCrewSelectValue = (crew) => {
  if (!crew?.crewCode && !crew?.firstName) return null;

  const normalized = {
    firstName: crew.firstName || '',
    lastName: crew.lastName || '',
    crewCode: crew.crewCode || '',
    sapBPNumber: getSapBPNumber(crew),
    rankName: crew.rankName || '',
    positionName: crew.positionName || ''
  };

  return {
    ...normalized,
    label: formatCrewDropdownLabel(normalized)
  };
};

const normalizeCrewList = (crewList = []) => (
  Array.isArray(crewList)
    ? crewList.map((crew) => ({
      ...crew,
      sapBPNumber: getSapBPNumber(crew)
    }))
    : crewList
);

export {
  getSapBPNumber,
  formatCrewDisplayName,
  formatCrewNameWithSapBP,
  formatCrewDropdownLabel,
  buildCrewSelectValue,
  normalizeCrewList
};
